import { http } from "@/helpers/http";
import Vue from 'vue'

// const baseURL = 'https://jfy8539qv5.execute-api.us-east-1.amazonaws.com/dev/v1';
// const baseURL = 'http://localhost:3000/dev/v1';

const baseURL = "/settings/v1";

export default {
    namespaced: true,
    state: {
        account: null,
        weightPricing: null,
        shipping: null,
        qr: null
    },

    getters: {
        account(state) {
            return state.account;
        },
        weightPricing(state) {
            return state.weightPricing;
        },
        shipping(state) {
            return state.shipping;
        },
        qr(state) {
            return state.qr;
        },
    },

    mutations: {
        setAccount(state, value) {
            Vue.set(state, 'account', value);
        },
        setWeightPricing(state, value) {
            Vue.set(state, 'weightPricing', value);
        },
        setShipping(state, value) {
            Vue.set(state, 'shipping', value);
        },
        setQr(state, value) {
            Vue.set(state, 'qr', value);
        },
    },

    actions: {
        async fetchSetting({ state, commit, rootState }, payload) {
            try {
                const { data } = await http.get(`${baseURL}/settings/${payload.type}`)

                return { status: true, data }
            } catch (e) {
                console.log(e)
                return { status: false }
            }
        },

        async updateSetting({ state, commit, rootState }, payload) {
            try {
                const { data } = await http.put(`${baseURL}/settings/${payload.type}`, payload.data)
                return { status: true, data }
            } catch (e) {
                console.log(e)
                return { status: false }
            }
        }
    }
}